import React, { useEffect } from 'react';
import AuthHeader from '../../components/header/AuthHeader';
import BannerRight from '../../components/BannerRight';
import AuthWrapper from '../../components/AuthWrapper';
import rocketBoyImg from '../../assets/images/barbfullLogo.png';
import { useTrackingContext } from '../../context/trackingContext';
import Footer from '../../components/Footer';

const Blocked = () => {
  const { trackPageView } = useTrackingContext();

  useEffect(() => {
    trackPageView({
      pageName: 'Unable to access everywhere. IP blocked'
    });
  }, []);

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="w-full lg:w-1/2 relative overflow-y-scroll left-form">
        <AuthHeader />
        <AuthWrapper className="max-w-sm">
          <div id="unable-view-ip">
            <img src={rocketBoyImg} alt="build rocket boy" className="w-full mb-8" />
            <h6 className="font-Korolev-Bold text-xl text-black text-center uppercase m-1">
              UNABLE TO ACCESS
            </h6>
            <p className="text-black text-center font-Korolev-Medium text-base mb-5">
              We are currently unable to handle your request at this time.
            </p>
          </div>
        </AuthWrapper>
        <Footer />
      </div>
      <BannerRight />
    </div>
  );
};

export default Blocked;
